import React, { useState } from 'react';
import get from 'lodash.get';
import { connect } from 'react-redux';
import clsx from 'clsx';
import { InitFetchPageDataHelper } from 'src/universal/redux/utils';
import { PageWrapper } from 'src/universal/components/PageWrapper';
import DcfBanner from 'src/universal/components/DcfBanner';
import { dispatchDtmActions } from 'src/universal/components/DispatchDtmActions';
import { FullWidthBackground } from 'acq-components/lib/composite-components/FullWidthBackground/FullWidthBackground';
import fullBackStyles from 'acq-components/lib/composite-components/FullWidthBackground/styles/intl-commercial/FullWidthBackground.scss?modules';
import { LeadForm } from './components/LeadForm';
import { StickyBar } from './components/StickyBar';
import TermsAndConditions from './components/TermsAndConditions';
import { FAQ } from 'src/universal/components/FAQ/';
import ReinforcementBanner from './components/ReinforcementBanner';
import { ThreeUp } from './components/ThreeUp';
import withPropTestingData from 'src/universal/components/WithPropTestingData';
import { DATA_TYPES } from 'src/universal/redux/propTesting';
import { pznPageIds } from 'src/universal/components/PZN/config';
import Breadcrumbs from 'src/universal/components/Breadcrumbs';
import CorpSegmentNav from './components/corpSegmentsNav/index';
import { getCorpSegmentsImpressions } from 'page_modules/corporate-category/redux';
import './__styles__/navs.scss';
import { name as pageName, className } from './__styles__/pageVars.scss';
import layoutStyles from './__styles__/layout.scss?modules';
import benefitsStyles from './__styles__/benefits.scss?modules';
import { isCardMember, isLoggedInCardMember } from 'src/universal/redux/userType';
import TimeSavingTools from 'page_modules/corporate-segments/components/TimeSavingTools';
import {
  hasMemberInfoArrived,
  getMemberCardTitles
} from 'src/universal/redux/cardMemberInfo.js';
import isUserZooming from 'src/universal/utils/isUserZooming';
import { isBrowser } from 'acq-utils/lib/misc';
import CorpVacHero from './components/CorpVacHero';
import CorpVacTiles from './components/CorpVacTiles';
import PdpTabbedContent from 'src/universal/components/PdpTabbedContent';
import { getCorpPdpTabbedData } from 'page_modules/corporate-category/redux';
import LazyScrollMetricTracker from 'src/universal/components/DTM/LazyScrollMetricTracker';
import faqStyles from 'src/universal/components/FAQ/__styles__/faqStyle.scss?modules';
import TestimonialCards from 'src/universal/components/Experiments/G166';
import TrackExperimentImpression from 'src/universal/components/TrackExperimentImpression';

const PropsTestedLeadForm = withPropTestingData(
  LeadForm,
  'leadForm',
  DATA_TYPES.pageData
);

const FetchPageDataHelper = new InitFetchPageDataHelper({
  pageName,
  debugMode: false
});
/* eslint-disable complexity */
const PageComponent = React.memo(
  ({
    dispatch,
    data = {},
    isCardMember = false,
    isUserLoggedIn = false,
    hasCMInfoArrived = false,
    cardTitles,
    corpPdpTabbedData
  }) => {
    const [showModalForm, setShowModalForm] = useState(false);

    dispatchDtmActions({
      FetchPageDataHelper,
      dispatch,
      data,
      dtmCategoryPaths: ['page.dtmPageName', 'page.subCategory2'],
      isCardMember,
      cardTitles,
      isUserLoggedIn,
      hasCMInfoArrived
    });

    const links = get(data, 'page.links') || [];
    const termsAndConditions = get(data, 'page.termsAndConditions') || [];
    const faqContent = data.page?.faq;
    const RIBContent = get(data, 'page.reinforcementBanner') || {};
    const getStartedContent = get(data, 'page.productTiles') || {};
    const formData = get(data, 'page.form[0]') || {};

    //for zoom detection
    const minWidth = 1023; //size in px where we switch to the tablet breakpoint
    let isZoomed = false;
    if (isBrowser() && window.innerWidth <= minWidth) {
      isZoomed = isUserZooming();
    }

    return (
      <PageWrapper
        displayName={className}
        FetchPageDataHelper={FetchPageDataHelper}
        data={data}
        pznPageId="open_corpVac"
        usePZN={true}
      >
        <TrackExperimentImpression experimentName="GCS-166-Testimonial-Cards" />
        <div
          className={clsx(layoutStyles.outerWrap, {
            [layoutStyles.modalForm]: showModalForm && !isZoomed,
            [layoutStyles.zoomingDesktop]: isZoomed
          })}
        >
          <FullWidthBackground
            styles={fullBackStyles}
            custClassName={layoutStyles.fullWidthWrap}
          >
            <div className={layoutStyles.topContent}>
              <div className={layoutStyles.leftRail}>
                <div
                  className={
                    isZoomed
                      ? layoutStyles.breadcrumbsContainerZoomed
                      : layoutStyles.breadcrumbsContainer
                  }
                >
                  <Breadcrumbs />
                </div>
                <CorpVacHero />
                <CorpVacTiles />
                <ReinforcementBanner
                  primaryContent={RIBContent.title}
                  secondaryContent={RIBContent.header}
                  subTitle={RIBContent.subTitle}
                />
                <PdpTabbedContent {...corpPdpTabbedData} instId="corpVac" />
                <TimeSavingTools />
                <CorpSegmentNav instId="corpSegments" />
                <TestimonialCards />
                <ThreeUp content={getStartedContent} styles={benefitsStyles} />
                <LazyScrollMetricTracker
                  scrollDtm={{ ...faqContent?.faqImpressionDTM }}
                />
                <FAQ content={faqContent} styles={faqStyles} />
              </div>
              <PropsTestedLeadForm
                content={{
                  form: formData,
                  links
                }}
                layoutStyles={layoutStyles}
                dismissModalForm={() => {
                  setShowModalForm(false);
                }}
              />
            </div>
          </FullWidthBackground>
          <div className={layoutStyles.bottomContent}>
            <LazyScrollMetricTracker
              scrollDtm={{ ...termsAndConditions?.TNCImpressionDTM }}
            />
            <TermsAndConditions content={termsAndConditions} />
          </div>
          <StickyBar
            content={links}
            launchForm={() => {
              setShowModalForm(true);
            }}
          />
          <DcfBanner pageType="corporate" pageId={pznPageIds.corpCategory} />
        </div>
      </PageWrapper>
    );
  }
);

FetchPageDataHelper.pageDataSetup(PageComponent, className);

export default connect(state => {
  const isUserMember = isCardMember(state);
  const titles = isUserMember ? getMemberCardTitles(state) : [];
  const data = {
    ...state[pageName]
  };
  return {
    data,
    isCardMember: isUserMember,
    isUserLoggedIn: isLoggedInCardMember(state),
    hasCMInfoArrived: hasMemberInfoArrived(state),
    cardTitles: titles,
    corpImpressionEvent: getCorpSegmentsImpressions(state),
    //leaving this even though it not being used right now
    //as we'll probably reuse it when dtm events come in
    corpPdpTabbedData: getCorpPdpTabbedData(state)
  };
})(PageComponent);
